import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type VoucherCompanyData} from './voucher-company';

export function voucherCompanyPatcher(data: VoucherCompanyData): RestTypeWithTypename<VoucherCompanyData> {
    return {
        __typename: 'VoucherCompanyData',
        billPayers: data.billPayers.map(b => ({
            ...b,
            __typename: 'VoucherCompanyBillPayer',
            shares: {...b.shares, __typename: 'VoucherCompanyBillPayerShares'},
        })),
        children: data.children.map(c => ({...c, __typename: 'VoucherCompanyChild'})),
    };
}
